<ng-template #voidTemplate let-column="column" let-element="element">
  <mat-checkbox checked="{{ element['statusVoided'] }}" disabled="true" />
</ng-template>
<ng-template #settledTemplate let-column="column" let-element="element">
  <mat-checkbox checked="{{ element['isSettled'] }}" disabled="true" />
</ng-template>
<ng-template #statusTemplate let-column="column" let-element="element">
  <div style="display: flex; align-items: center; gap: 8px">
    <i
      *ngIf="element['status'] === 'active' && (!element['failedPayments'] || element['failedPayments'] === 0)"
      class="fa-solid fa-circle-check"
      style="color: #4caf50"
    ></i>
    <i
      *ngIf="element['status'] === 'active' && element['failedPayments'] > 0"
      class="fa-solid fa-triangle-exclamation"
      style="color: #ff9800"
      matTooltip="Payment has {{ element['failedPayments'] }} failed attempt(s). Will retry on next cycle."
      matTooltipPosition="right"
    ></i>
    <i *ngIf="element['status'] === 'paused'" class="fa-solid fa-circle-pause" style="color: #ff9800"></i>
    <i *ngIf="element['status'] === 'failed'" class="fa-solid fa-circle-exclamation" style="color: #f44336"></i>
    <i *ngIf="element['status'] === 'completed'" class="fa-solid fa-circle-check" style="color: #2196f3"></i>
    <i *ngIf="element['status'] === 'cancelled'" class="fa-solid fa-circle-xmark" style="color: #f44336"></i>
    <span>{{ element['status'] | capitalize }}</span>
    <span
      *ngIf="element['status'] === 'active' && element['failedPayments'] > 0"
      style="color: #ff9800; font-size: 0.85em; font-weight: 500"
      >({{ element['retryCount'] || element['failedPayments'] }}/3 retries)</span
    >
  </div>
</ng-template>
<ng-template #tranTypeTemplate let-column="column" let-element="element">
  <div class="position-relative" style="display: flex; justify-content: space-between; align-items: center">
    <span>{{ element['transactionType'] | capitalize }}</span>
    <img
      src="assets/onetimepay-stamp.svg"
      *ngIf="element['isOneTimePayment'] == true"
      class="card-type-icon"
      style="margin-bottom: 6px"
      alt="one-time payment"
      matToolTipPosition="right"
      matToolTip="One Time Payment"
    />
    <div
      style="
        display: flex;
        justify-content: center;
        vertical-align: middle;
        align-items: left;
        text-align: left;
        margin-top: 8px;
      "
    >
      <mat-icon
        *ngIf="element['statusDeclined'] === true || element['statusSuccess'] === false"
        style="color: #f44336"
        class="indicator"
        matTooltip="Transaction Failed"
        matTooltipPosition="right"
        >error</mat-icon
      >
      <mat-icon
        *ngIf="element['processorCustRef']?.startsWith('SP')"
        color="primary"
        class="indicator"
        matTooltip="Scheduled Payment"
        matTooltipPosition="right"
        >calendar_month</mat-icon
      >
      <mat-icon
        *ngIf="element['isACHTransaction'] == true"
        color="primary"
        matTooltip="ach"
        class="indicator"
        matTooltipPosition="right"
        >account_balance</mat-icon
      >
      <mat-icon
        *ngIf="element['isACHTransaction'] == false"
        color="primary"
        class="indicator"
        matTooltip="credit card"
        matTooltipPosition="right"
        >credit_card</mat-icon
      >
      <mat-icon
        *ngIf="element['freelyContextChannel'] == 'ACCEPT'"
        color="primary"
        class="indicator"
        matTooltip="ACCEPT"
        matTooltipPosition="right"
        >web</mat-icon
      >
      <mat-icon
        *ngIf="element['statusVoided'] == true"
        color="warn"
        class="indicator"
        matTooltip="voided"
        matTooltipPosition="right"
        >cancel</mat-icon
      >
      <mat-icon
        *ngIf="element['freelyContextChannel'] == 'FLASHPAY'"
        color="primary"
        class="indicator"
        matTooltip="flashpay"
        matTooltipPosition="right"
        >bolt</mat-icon
      >
      <mat-icon
        *ngIf="element['freelyContextChannel'] == 'DEVICE'"
        color="primary"
        class="indicator"
        matTooltip="point of sale"
        matTooltipPosition="right"
        >point_of_sale</mat-icon
      >
      <mat-icon
        *ngIf="element['freelyContextChannel'] == 'HOSTEDPAGE'"
        color="primary"
        class="indicator"
        matTooltip="web"
        matTooltipPosition="right"
        >cloud</mat-icon
      >
    </div>
  </div>
</ng-template>
<ng-template #transIdTemplate let-column="column" let-element="element">
  <span
    [style.color]="element['statusDeclined'] === true || element['statusSuccess'] === false ? '#f44336' : 'inherit'"
    [style.font-weight]="element['statusDeclined'] === true || element['statusSuccess'] === false ? '600' : 'normal'"
  >
    {{ element['transactionId'] }}
  </span>
</ng-template>
<ng-template #flagsTemplate let-column="column" let-element="element" let-row="row">
  <mat-icon
    *ngIf="element['isACHTransaction']"
    color="primary"
    matTooltip="ACH"
    style="font-size: 16px"
    matTooltipPosition="right"
  >
    account_balance
  </mat-icon>
</ng-template>
<ng-template #cardTypeTemplate let-column="column" let-element="element">
  <span class="card-type-{{ element.accountType | dashcase }}">
    {{ element.accountType | uppercase }}
  </span>
</ng-template>
<ng-template #setDefaultTemplate let-column="column" let-element="element">
  <mat-checkbox [formControl]="element.isDefaultFormControl" [value]="element.id" />
</ng-template>
<ng-template #invoiceStatusTemplate let-column="column" let-element="element">
  <div style="display: flex; align-items: center; gap: 8px">
    <i *ngIf="element['status'] === 'complete'" class="fa-solid fa-circle-check" style="color: #4caf50"></i>
    <i *ngIf="element['status'] === 'scheduled'" class="fa-solid fa-calendar-check" style="color: #2196f3"></i>
    <i *ngIf="element['status'] === 'declined'" class="fa-solid fa-circle-xmark" style="color: #f44336"></i>
    <i *ngIf="element['status'] === 'autopay'" class="fa-solid fa-rotate" style="color: #9c27b0"></i>
    <i *ngIf="element['status'] === 'overdue'" class="fa-solid fa-circle-exclamation" style="color: #ff9800"></i>
    <i *ngIf="element['status'] === 'partial'" class="fa-solid fa-circle-half-stroke" style="color: #ffc107"></i>
    <i *ngIf="element['status'] === 'new'" class="fa-solid fa-clock" style="color: #607d8b"></i>
    <span>{{ element['status'] | capitalize }}</span>
  </div>
</ng-template>
<ng-template #invoiceActionsTemplate let-column="column" let-element="element">
  <div style="display: flex; gap: 8px; min-width: 280px; white-space: nowrap">
    <button
      mat-button
      color="primary"
      *ngIf="
        element['status'] !== 'complete' &&
        element['status'] !== 'notpayable' &&
        element['status'] !== 'notusable' &&
        element['status'] !== 'available' &&
        element['status'] !== 'partiallyapplied' &&
        element['status'] !== 'fullyapplied'
      "
      (click)="collectPayment(element)"
    >
      Collect
    </button>
    <button
      mat-button
      color="accent"
      *ngIf="
        element['status'] !== 'complete' &&
        element['status'] !== 'scheduled' &&
        element['status'] !== 'notpayable' &&
        element['status'] !== 'notusable' &&
        element['status'] !== 'available' &&
        element['status'] !== 'partiallyapplied' &&
        element['status'] !== 'fullyapplied'
      "
      (click)="schedulePayment(element)"
    >
      Schedule
    </button>
  </div>
</ng-template>

<div style="display: flex; flex-direction: column; height: 100%" class="app-customer-details">
  <!-- A ship-to account is listed everywhere, but money is taken at its bill-to. Said once here,
       on the record itself, because Collect Payment does not offer the account at all and an
       operator who cannot find it there needs to be told why rather than left guessing. -->
  <div *ngIf="customerData?.shipToOnly" class="app-customer-details__ship-to-notice">
    <i class="fa-solid fa-circle-info"></i>
    <span>
      <strong>Delivery location only.</strong>
      This account holds no invoices of its own — the ERP bills
      <ng-container *ngIf="customerData?.parentCustomerName; else unnamedBillTo">
        {{ customerData?.parentCustomerName }}</ng-container
      ><ng-template #unnamedBillTo>a different account</ng-template>, and payment is taken there.
    </span>
  </div>

  <!-- The customer's name, account and address sit ABOVE the tab strip, so who this is stays in
       view on every tab. It replaces the sheet's title, which only repeated the name. The account
       figures are on the Dashboard tab. -->
  <app-customer-summary
    [customerId]="customerId"
    [customerData]="customerData"
    [showStats]="false"
  ></app-customer-summary>

  <mat-button-toggle-group
    #tabStrip
    class="app-batch-details__tabs"
    name="batchDetails"
    aria-label="Customer view"
    [value]="currentView"
    (change)="onViewChange($event)"
  >
    <mat-button-toggle value="dashboard" *ngIf="isInvoiceEnabled()">Dashboard</mat-button-toggle>
    <!-- Immediately after the Dashboard: the customer's own record is what people reach for most
         after the overview, and it used to sit at the far right past six financial tabs. -->
    <mat-button-toggle *hasPermission="'UPDATE_CUSTOMER'" value="editor">Customer Info</mat-button-toggle>
    <mat-button-toggle value="transactions">Customer Payments</mat-button-toggle>
    <mat-button-toggle value="scheduledPayments" *ngIf="isScheduledPaymentsEnabled()"
      >Scheduled Payments</mat-button-toggle
    >
    <mat-button-toggle value="invoices" *ngIf="isInvoiceEnabled()">Invoices</mat-button-toggle>
    <mat-button-toggle value="ledger" *ngIf="canViewLedger()">Ledger</mat-button-toggle>
    <mat-button-toggle value="accounts" *ngIf="isAccountsOnFileEnabled()">Accounts on File</mat-button-toggle>
    <ng-container *ngIf="isCustomerPortalEnabled()">
      <mat-button-toggle *hasPermission="'UPDATE_CUSTOMER'" value="portalAccounts">Portal Accounts</mat-button-toggle>
    </ng-container>
    <!-- <mat-button-toggle value="cards">Cards</mat-button-toggle> -->

    <!-- <mat-button-toggle value="requests">Requests</mat-button-toggle> -->
  </mat-button-toggle-group>
  <!-- min-height, NOT height. A fixed 600px with no `overflow` does not scroll
       — it reserves 600px and lets anything taller spill out, painting over
       whatever follows in the flow. The page footer is an ordinary <footer>
       after <main>, so a customer with more than ~9 invoices had rows rendering
       straight through the black footer bar. `min-height` keeps the floor that
       stops the page jumping as you switch between a short tab and a long one,
       while letting real content size the page so the single page scrollbar
       works and the footer is pushed below it. -->
  <div style="min-height: 600px">
    <div style="flex: 1 1 auto" *ngIf="currentView === 'dashboard' && isInvoiceEnabled()">
      <app-customer-summary
        [customerId]="customerId"
        [customerData]="customerData"
        [showIdentity]="false"
      ></app-customer-summary>
    </div>

    <customer-editor
      *ngIf="currentView === 'editor'"
      customerId="{{ customerId }}"
      [hasDefaultPaymentMethod]="hasDefaultPaymentMethod"
      (onSaveSuccess)="handleEditorClose()"
      (onCancel)="handleEditorClose()"
    ></customer-editor>
    <div style="flex: 1 1 auto" *ngIf="currentView === 'transactions'">
      <div class="page__toolbar" style="margin-top: 8px">
        <button *hasPermission="'TRANSACTION_SALE'" mat-raised-button color="primary" (click)="newPayment()">
          New Payment
        </button>
        <span style="flex: 1 1 auto"></span>
        <button *hasPermission="'GET_TRANSACTIONS'" mat-button color="primary" (click)="downloadFilteredPDF()">
          download filtered pdf
        </button>
        <button *hasPermission="'GET_TRANSACTIONS'" mat-raised-button color="primary" (click)="downloadFullCSV()">
          download full csv
        </button>
      </div>

      <!-- On an ERP + invoicing profile the customer's money mostly arrives as
           an import, which has no DBTransactions row — so the old grid showed
           only what Freely processed and everything else was missing from the
           customer's own page. The dashboard's list is embedded rather than
           copied: one implementation, and the two screens cannot disagree. -->
      @if (showFreelyPayments()) {
        <app-payment-history
          [customerId]="customerId"
          [embedded]="true"
          (navigate)="handlePaymentNavigation($event)"
        ></app-payment-history>
      } @else {
        <app-grid
          #transactionsGrid
          [data]="transactions$"
          [config]="transactionsConfig"
          [templateRefs]="templateRefs()"
          *ngIf="currentView === 'transactions'"
        ></app-grid>
      }
    </div>

    <div style="flex: 1 1 auto" *ngIf="currentView === 'scheduledPayments'">
      <div class="page__toolbar" style="margin-top: 8px">
        <button
          *hasPermission="'SCHEDULED_PAYMENT_CREATE'"
          mat-raised-button
          color="primary"
          (click)="newScheduledPayment()"
        >
          New Scheduled Payment
        </button>
        <span style="flex: 1 1 auto"></span>
      </div>

      <app-grid
        [data]="scheduledPayments$"
        [config]="scheduledPaymentsConfig"
        [templateRefs]="templateRefs()"
        *ngIf="currentView === 'scheduledPayments'"
      ></app-grid>
    </div>

    <div style="flex: 1 1 auto" *ngIf="currentView === 'invoices' && isInvoiceEnabled()">
      <app-customer-invoice-history
        [customerId]="customerId"
        [customerData]="customerData"
        [hasPaymentMethods]="hasAnyPaymentMethods"
        [ledgerEnabled]="isCustomerLedgerEnabled()"
        [canViewLedger]="canViewLedger()"
        (collectClicked)="handleInvoiceCollectClicked()"
        (viewLedger)="handleViewInvoiceLedger($event)"
      ></app-customer-invoice-history>
    </div>

    <!-- `height: 100%` was resolving against the fixed 600px above; with the
         parent auto-sized it would resolve to `auto` and mean nothing, so it is
         gone rather than left looking load-bearing. The ledger carries no
         internal scroll of its own, so it grows the page like every other tab. -->
    <div style="flex: 1 1 auto" *ngIf="currentView === 'ledger' && canViewLedger()">
      <app-customer-ledger
        [customerId]="customerId"
        [customerName]="customerData?.displayName || customerData?.companyName || null"
        [documentRef]="ledgerDocumentRef"
      ></app-customer-ledger>
    </div>

    <!-- Cards and bank accounts together, drawn with the same account cards as Collect Payment's
         "which account" step (`app-account-card`), each section ending in its own add tile. -->
    <div style="flex: 1 1 auto" *ngIf="currentView === 'accounts' && isAccountsOnFileEnabled()">
      <div class="account-picker" style="margin-top: 16px" aria-label="Accounts on file">
        @if (isCardsOnFileEnabled()) {
          <section class="account-picker__section">
            <h3 class="account-picker__heading">
              Cards <span class="account-picker__count">{{ accountCards().length }}</span>
            </h3>
            <div class="account-picker__grid">
              @for (item of accountCards(); track item.method.id) {
                <app-account-card
                  [item]="item"
                  [actions]="accountActionsFor(item)"
                  (setDefault)="setDefaultPaymentMethod($any($event.id))"
                  (action)="runAccountAction($event, item)"
                />
              }
              <button type="button" class="account-card account-card--add" (click)="openAddCardModal()">
                <mat-icon aria-hidden="true">add_card</mat-icon>
                add card
              </button>
            </div>
          </section>
        }

        @if (isAchPayEnabled()) {
          <section class="account-picker__section">
            <h3 class="account-picker__heading">
              Bank accounts (ACH) <span class="account-picker__count">{{ achAccountCards().length }}</span>
            </h3>
            <div class="account-picker__grid">
              @for (item of achAccountCards(); track item.method.id) {
                <app-account-card
                  [item]="item"
                  [actions]="accountActionsFor(item)"
                  (setDefault)="setDefaultPaymentMethod($any($event.id))"
                  (action)="runAccountAction($event, item)"
                />
              }
              <button type="button" class="account-card account-card--add" (click)="openAddAchModal()">
                <mat-icon aria-hidden="true">account_balance</mat-icon>
                add ACH account
              </button>
            </div>
          </section>
        }
      </div>
    </div>

    <div style="flex: 1 1 auto" *ngIf="currentView === 'portalAccounts'">
      <div class="page__toolbar" style="margin-top: 8px">
        <button mat-raised-button color="primary" (click)="addPortalUser()">Add Portal User</button>
        <span style="flex: 1 1 auto"></span>
      </div>

      <app-grid
        [data]="portalUsers$"
        [config]="portalAccountsConfig"
        [templateRefs]="templateRefs()"
        [parent]="this"
        *ngIf="currentView === 'portalAccounts'"
      ></app-grid>
    </div>

    <div style="flex: 1 1 auto"></div>
  </div>
</div>
